import { render, staticRenderFns } from "./ModalFramePage.vue?vue&type=template&id=2032a5ba&scoped=true"
import script from "./ModalFramePage.vue?vue&type=script&lang=ts"
export * from "./ModalFramePage.vue?vue&type=script&lang=ts"
import style0 from "./ModalFramePage.vue?vue&type=style&index=0&id=2032a5ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2032a5ba",
  null
  
)

export default component.exports